<template>
  <BasicButton
    :class="['form-submit-button', textOnly && 'form-submit-button--text-only']"
    html-type="submit"
    v-bind="$attrs"
  >
    <template #icon>
      <slot name="icon" />
    </template>

    <span>
      <slot></slot>
    </span>
  </BasicButton>
</template>

<style lang="scss">
.form-submit-button {
  min-width: clamp(260px, 50vw, 360px);
  height: $btn-height;

  & > span {
    display: inline-block; // Required display value for :first-letter
    text-transform: lowercase; // Set default text-transform

    &:first-letter {
      text-transform: uppercase;
    }
  }

  @media screen and (max-width: $screen-sm) {
    min-width: 100%;
    width: 100%;
  }
}
</style>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import BasicButton from "@/shared/components/buttons/BasicButton.vue";
import { useRoute } from "vue-router";
import useLogging from "@/shared/composables/useLogging";
import notification from "ant-design-vue/lib/notification";

export default defineComponent({
  props: {
    textOnly: Boolean,
  },
  setup() {
    const t = useI18n().t;
    const route = useRoute();
    // Create Log
    const { submitInfoToApi } = useLogging();

    onMounted(() => {
      const onClickSubmitButton = () => {
        // Pass Logs
        submitInfoToApi(`Clicked FormSubmitButton on route ${route.fullPath}`);
      };

      // Fetch document
      const submitButtons = document.querySelector(".form-submit-button");

      /** Add a Click Event Listener */
      if (submitButtons !== null)
        submitButtons?.addEventListener("click", onClickSubmitButton);
    });

    onUnmounted(() => {
      // When button is clicked and proceeds to next view or page, destroy any existing toast.
      notification.destroy();
    });

    return { t };
  },
  components: {
    BasicButton,
  },
});
</script>
